module.exports = __webpack_public_path__ + "img/slide3.f08a7654.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":419,"height":356,"variants":[]};
}